import { BrowserRouter as Router, Route, Routes } from 'react-router-dom'
import "./App.css"
import { API_URL } from './components/01_config/api';
import { useSelector, useDispatch } from 'react-redux';
import { useEffect, useRef } from 'react';
import { Outlet } from "react-router-dom";
import ScrollToTop from './components/01_config/ScrollToTop';
import Header from './components/02_header/Header';
import Home from './pages/01_home/Home';
import About from "./pages/02_about/About"
import MyProgress from "./pages/02_myprogress/MyProgress"
import Lesson from './pages/02_myprogress/03_lessonPage/Lesson';
import Vocabulary from './pages/03_vocabulary/Vocabulary';
import Grammar from "./pages/04_grammar/Grammar"
import Reading from "./pages/05_reading/Reading"
import ReadingTexts from './pages/05_reading/02_texts/ReadingTexts';
import ReadingSigns from './pages/05_reading/03_signs/ReadingSigns';
import Listening from "./pages/06_listening/Listening"
import Speaking from "./pages/07_speaking/Speaking"
import Dialogs from './pages/07_speaking/02_dialogs/Dialogs';
import Stories from "./pages/07_speaking/03_stories/Stories"
import AdminDashboard from './pages/08_admin/AdminDashboard';
import TeacherDashboard from './pages/09_teacher/TeacherDashboard';
import ProtectedRoute from "./components/01_config/ProtectedRoute"
import Footer from './components/03_footer/Footer';
import ContactForm from './components/03_footer/01_contactform/ContactForm';
import Dimmer from './components/04_common/01_dimmer/Dimmer';
import { fetchStudentLessons } from "./features/studentLessons/studentLessonsSlice";
import { useAutoLogoutOnInactivity } from "./hooks/useLogout";

const App = () => {

  useAutoLogoutOnInactivity();
  
  const dispatch = useDispatch();
  const token = useSelector((state) => state.auth.token);
  const justLoggedIn = useSelector((state) => state.auth.justLoggedIn);
  const { lessons, loading, error } = useSelector((state) => state.studentLessons);
  const lang = useSelector(state => state.lang.lang)
  const dimmedOn = useSelector((state) => state.forms.dimmed)

  useEffect(() => {
    if (!token) return;                  // not logged in
    if (loading) return;                 // already loading
    if (justLoggedIn) return;            // avoid competing during click-login
    if (lessons && lessons.length > 0) return; // already loaded
    if (error) return

    dispatch(fetchStudentLessons());

  }, [token, justLoggedIn, lessons, loading, error, dispatch]);

  useEffect(() => {
    document.documentElement.lang = lang;
  }, [lang]);

// useEffect(() => {
//   fetch(`${API_URL}/health`, { method: "GET" })
//     .catch(() => {});
// }, []);

  return (
    <div>
      {dimmedOn && <Dimmer />}
      <Router>
        <ScrollToTop />
        <Header />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/reset-password" element={<Home resetPasswordMode={true} />} />
          <Route path="/about" element={<About />} />

          <Route path="/myprogress">
            <Route path="" element={<MyProgress />} />

            <Route
              path="lesson"
              element={
                <ProtectedRoute
                  allowedRoles={["STUDENT", "TEACHER", "ADMIN"]}
                  fallback={<MyProgress />}
                >
                  <Lesson />
                </ProtectedRoute>
              }
            />
          </Route>

          <Route path="/vocabulary" element={<Vocabulary />} />
          <Route path="/grammar" element={<Grammar />} />
          <Route path="/reading">
            <Route path="" element={<Reading />} />
            <Route path="texts" element={<ReadingTexts />} />2
            <Route path="signs" element={<ReadingSigns />} />
          </Route>
          <Route path="/listening" element={<Listening />} />
          <Route path="/speaking">
            <Route path="" element={<Speaking />} />
            <Route path="dialogues" element={<Dialogs />} />
            <Route path="stories" element={<Stories />} />
          </Route>
          <Route path="/admin"
            element={
              <ProtectedRoute allowedRoles={["ADMIN"]}>
                <AdminDashboard />
              </ProtectedRoute>
            } />
          <Route path="/teacher"
            element={
              <ProtectedRoute allowedRoles={["ADMIN", "TEACHER"]}>
                <TeacherDashboard />
              </ProtectedRoute>
            } />
          <Route path="/contactform" element={<ContactForm />} />
        </Routes>
        <Footer />
      </Router>
    </div>
  );
}

export default App;